/**
 * frontend/src/tabs/RankingsTab.jsx
 * SoundDAO Sprint 6A — Rankings tab (Leaderboard + Live Feed merged)
 *
 * Top: player's own rank card (always visible)
 * Toggle: Leaderboard | Live Feed
 * Body: renders existing Leaderboard component with activeTab pre-set
 *
 * Props:
 *   session — Supabase auth session
 *   user    — users row
 */

import React, { useState, useEffect, useCallback } from 'react';
import Leaderboard from '../pages/Leaderboard';
import './RankingsTab.css';
import { authFetch } from '../lib/authFetch';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001';

// Rank is SERVED BY THE BACKEND (Sprint 6-Zero Milestone 2) — lib/rankLadder.js
// is the single source of truth. The local table that used to sit here computed
// from spendable balance and disagreed with both the dashboard and the agents.

export default function RankingsTab({ session, user }) {
  const user_id = session?.user?.id;
  const [globalRank, setGlobalRank] = useState(null);
  const [balance, setBalance]       = useState(0);
  const [bcRank, setBcRank]         = useState(null);

  const loadRank = useCallback(async () => {
    if (!user_id) return;
    try {
      const rankRes = await authFetch(`${API_BASE}/api/leaderboard/players/me?user_id=${user_id}`);
      if (rankRes.ok) {
        const rd = await rankRes.json();
        setGlobalRank(rd.global_rank || null);
        setBcRank(rd.big_creative_rank || null);
      }
    } catch { /* non-fatal */ }
    try {
      const balRes = await authFetch(`${API_BASE}/api/rewards/balance/${user_id}`);
      if (balRes.ok) {
        const d = await balRes.json();
        setBalance(d.sound_balance || 0);
      }
    } catch { /* non-fatal */ }
  }, [user_id]);

  useEffect(() => { loadRank(); }, [loadRank]);

  // Server-computed; falls back to the persisted rank_title, never to a guess.
  const currentRankTitle = bcRank?.title || user?.rank_title || null;

  return (
    <div className="rankings-tab">
      {/* Player's own rank banner — pinned at top */}
      {user_id && (
        <div className="rankings-my-rank">
          <span className="rankings-my-rank-text">
            Ranked <strong>#{globalRank || '—'}</strong> globally
            {' · '}
            {balance.toLocaleString()} SOUND
            {currentRankTitle && (
              <>
                {' · '}
                {currentRankTitle}
              </>
            )}
            <span className="rankings-my-rank-you">you</span>
          </span>
        </div>
      )}

      {/* Existing Leaderboard component (contains Feed + Players + Creators tabs) */}
      <Leaderboard session={session} user={user} />
    </div>
  );
}
